define('SageDotCom/DataLayer/Events/productCardScrollView',[
        "jquery",
        "SageDotCom/DataLayer/Events/eventBase"
    ],
    function ($, EventBase) {

        function ProductCardViewEvent() {
            EventBase.call(this); // inherit eventBase
            this.name = "product_card_view"; // overwrite name
        }

        ProductCardViewEvent.prototype = Object.create(EventBase.prototype);

        ProductCardViewEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(productFamily) {
            
            var eventData = {
                'event_name': this.getName(),
                'item_list_name': productFamily
            }
            return eventData;
        }
        return new ProductCardViewEvent();
    });
